import { axiosGetHandler, axiosPostHandler } from "./config";
import { extractAPIValues } from "_lib/utils/utils";
const { BASE_API } = extractAPIValues();

// 更新用户小程序列表
export function updateMiniProgramFolder(param, data) {
  const url = BASE_API + "/chatroom/v2/common/mini_program/folders";
  return axiosPostHandler(url, param, data);
}

// 获取用户小程序列表
export function getMiniProgramFolder(param) {
  const url = BASE_API + "/chatroom/v2/common/mini_program/folders";
  return axiosGetHandler(url, param);
}

// 获取小程序推荐列表
export function getRecommendMiniProgram(param) {
  const url = BASE_API + "/chatroom/v2/common/mini_program/reco";
  return axiosGetHandler(url, param);
}

// 删除小程序推荐列表
export function deleteRecommend(param, data) {
  const url = BASE_API + "/chatroom/v2/common/mini_program/reco/remove";
  return axiosPostHandler(url, param, data);
}

// 小程序弹窗获取小程序列表
export function getMiniProgramList(param = {}) {
  const url = BASE_API + "/chatroom/v2/common/mini_program/list";
  return axiosGetHandler(url, param);
}

// 搜索小程序
export function searchMiniProgram(param = {}) {
  const url = BASE_API + "/chatroom/v2/minipro/search";
  return axiosGetHandler(url, param);
}


// 准星工具小程序获取分享码信息
export function getCrosshairShareCodeInfo(param = {}) {
  const url = BASE_API + "/chatroom/v2/game/sight_square/sight/receive";
  return axiosGetHandler(url, param);
}

// 获取游戏浮窗助手对应小程序列表
export function getOverlayMiniProgramList(param = {}) {
  const url = BASE_API + "/chatroom/v2/minipro/overlay_manager";
  return axiosGetHandler(url, param);
}

// 最近使用小程序
export function reportRecentUserMp(param = {}) {
  const url = BASE_API + "/chatroom/v2/minipro/use";
  return axiosGetHandler(url, param);
}

// 获取分享页信息
export function getSharePageInfo(params = {}) {
  const url = BASE_API + '/chatroom/v2/minipro/share_page';
  return axiosGetHandler(url, params);
}
